import React, { useState, useEffect } from 'react';
import { useAuth, apiFetch } from '../App';
import { useNavigate } from 'react-router-dom';

const FLW_PACKAGES = [
  { id:"flw_500",   ngn:500,   credits:25,  bonus:0,   label:"Starter", popular:false },
  { id:"flw_1000",  ngn:1000,  credits:55,  bonus:5,   label:"Popular", popular:true  },
  { id:"flw_2000",  ngn:2000,  credits:115, bonus:15,  label:"Pro",     popular:false },
  { id:"flw_5000",  ngn:5000,  credits:300, bonus:50,  label:"Whale",   popular:false },
  { id:"flw_10000", ngn:10000, credits:650, bonus:150, label:"Titan",   popular:false },
];

const PROVIDERS = ['MTN','Airtel','Glo','9mobile'];

const STORE_ITEMS = [
  { id:"airtime_mtn_100",    type:"airtime", provider:"MTN",    value:100, stars:120,  label:"MTN ₦100 Airtime"    },
  { id:"airtime_mtn_200",    type:"airtime", provider:"MTN",    value:200, stars:230,  label:"MTN ₦200 Airtime"    },
  { id:"airtime_mtn_500",    type:"airtime", provider:"MTN",    value:500, stars:575,  label:"MTN ₦500 Airtime"    },
  { id:"airtime_airtel_100", type:"airtime", provider:"Airtel", value:100, stars:120,  label:"Airtel ₦100 Airtime" },
  { id:"airtime_airtel_200", type:"airtime", provider:"Airtel", value:200, stars:230,  label:"Airtel ₦200 Airtime" },
  { id:"airtime_airtel_500", type:"airtime", provider:"Airtel", value:500, stars:575,  label:"Airtel ₦500 Airtime" },
  { id:"airtime_glo_100",    type:"airtime", provider:"Glo",    value:100, stars:120,  label:"Glo ₦100 Airtime"    },
  { id:"airtime_glo_200",    type:"airtime", provider:"Glo",    value:200, stars:230,  label:"Glo ₦200 Airtime"    },
  { id:"airtime_9mobile_100",type:"airtime", provider:"9mobile",value:100, stars:120,  label:"9mobile ₦100 Airtime"},
];

export default function StorePage() {
  const { user, setUser, showToast, loadMe } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab]               = useState('topup');
  const [orders, setOrders]         = useState([]);
  const [flwLoading, setFlwLoading] = useState(false);
  const [selPkg, setSelPkg]         = useState(null);

  // Airtime state
  const [provider, setProvider]     = useState('MTN');
  const [phone, setPhone]           = useState('');
  const [selItem, setSelItem]       = useState(null);
  const [customAmt, setCustomAmt]   = useState('');
  const [airtimeLoading, setAirtimeLoading] = useState(false);

  function detectNetwork(phone) {
    const p = phone.replace(/\s/g,'').replace(/^\+?234/,'0');
    if (!p.startsWith('0') || p.length < 4) return null;
    const pfx = p.slice(0,4);
    const map = {
      MTN:      ['0803','0806','0813','0816','0810','0814','0903','0906','0913','0916','0704','0706','0703'],
      Airtel:   ['0802','0808','0812','0701','0708','0902','0907','0901','0912','0911'],
      Glo:      ['0805','0807','0815','0705','0905','0915','0811'],
      '9mobile':['0809','0817','0818','0908','0909','0817'],
    };
    for (const [net, prefixes] of Object.entries(map)) {
      if (prefixes.includes(pfx)) return net;
    }
    return null;
  }

  function handlePhoneChange(val) {
    setPhone(val);
    // Do NOT auto-switch — just show warning like the bot does
  }
  const [orderOk, setOrderOk]       = useState(null);

  // Withdraw state
  const [banks, setBanks]           = useState([]);
  const [bankSearch, setBankSearch] = useState('');
  const [showBankList, setShowBankList] = useState(false);
  const [bank, setBank]             = useState('');
  const [bankCode, setBankCode]     = useState('');
  const [acctNo, setAcctNo]         = useState('');
  const [acctName, setAcctName]     = useState('');
  const [acctNameLoading, setAcctNameLoading] = useState(false);
  const [acctNameVerified, setAcctNameVerified] = useState(false);
  const [wdAmount, setWdAmount]     = useState('');
  const [wdLoading, setWdLoading]   = useState(false);

  useEffect(() => {
    if (!user) { navigate('/auth'); return; }
    apiFetch('/api/web/store/my-orders').then(setOrders).catch(()=>{});
    apiFetch('/api/flw/banks').then(d => setBanks(Array.isArray(d)?d:(d.data||[]))).catch(()=>{});

    // Check if user returned from Flutterwave payment
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const txRef  = params.get('tx_ref');
    if (status === 'successful' && txRef) {
      showToast('Payment successful! ✅ Stars will be added shortly.', 'success');
      window.history.replaceState({}, '', '/store');
      // Refresh balance after short delay
      setTimeout(() => loadMe(), 3000);
    } else if (status === 'cancelled') {
      showToast('Payment was cancelled.', 'error');
      window.history.replaceState({}, '', '/store');
    }
  }, [user]);

  // Top up via Flutterwave
  async function handleTopup() {
    if (!selPkg) return showToast('Select a package first', 'error');
    setFlwLoading(true);
    try {
      const d = await apiFetch('/api/web/flw/topup', { method:'POST', body: selPkg.custom ? { stars: selPkg.credits, naira: selPkg.ngn } : { packageId: selPkg.id }});
      if (d.dev) {
        showToast(`✅ ${d.credits} ⭐ added!`, 'success');
        const updatedMe = await apiFetch('/api/web/me');
        setUser(updatedMe);
      } else if (d.paymentLink) {
        // Mobile-safe: use location.href instead of window.open (blocked on mobile after async)
        window.location.href = d.paymentLink;
        showToast('💳 Redirecting to payment...', 'info');
      }
    } catch(err) { showToast(err.message, 'error'); }
    setFlwLoading(false);
  }

  // Redeem airtime
  async function handleAirtime() {
    if (!selItem) return showToast('Select an airtime package', 'error');
    if (!phone) return showToast('Enter your phone number', 'error');
    if (!/^(0[789]\d{9})$/.test(phone.replace(/\s/g,''))) return showToast('Enter a valid Nigerian phone number', 'error');
    if (user.balance < selItem.stars) return showToast('Insufficient Stars balance', 'error');
    setAirtimeLoading(true);
    try {
      const d = await apiFetch('/api/web/store/redeem', {
        method:'POST',
        body:{ itemId: selItem.id, phone }
      });
      setOrderOk(d);
      const updatedMe2 = await apiFetch('/api/web/me');
      setUser(updatedMe2);
      showToast('Airtime ordered successfully!', 'success');
      setSelItem(null); setPhone('');
      apiFetch('/api/web/store/my-orders').then(setOrders).catch(()=>{});
    apiFetch('/api/flw/banks').then(d => setBanks(Array.isArray(d)?d:(d.data||[]))).catch(()=>{});
    } catch(err) { showToast(err.message, 'error'); }
    setAirtimeLoading(false);
  }

  // Lookup account name
  async function lookupAccount(acct, code) {
    console.log('[LOOKUP] acct:', acct, 'code:', code);
    if (acct.length !== 10 || !code) return;
    setAcctNameLoading(true);
    setAcctNameVerified(false);
    try {
      const d = await apiFetch('/api/web/flw/validate-account', { method:'POST', body:{ accountNumber:acct, bankCode:code }});
      console.log('[LOOKUP RESULT]', d);
      const name = d.account_name || d.data?.account_name || d.data?.full_name;
      if (name) {
        setAcctName(name);
        setAcctNameVerified(true);
      } else {
        setAcctName('');
        setAcctNameVerified(false);
      }
    } catch(e) { setAcctName(''); setAcctNameVerified(false); }
    setAcctNameLoading(false);
  }

  // Withdraw
  async function handleWithdraw() {
    const amt = parseInt(wdAmount);
    if (!amt || amt < 200) return showToast('Minimum withdrawal is 200 Stars', 'error');
    if (amt > user.withdrawableBalance) return showToast('Insufficient withdrawable balance', 'error');
    if (!bank || !bankCode || !acctNo || !acctName) return showToast('Fill all bank details', 'error');
    setWdLoading(true);
    try {
      await apiFetch('/api/web/withdraw', {
        method:'POST',
        body:{ stars: amt, bankName: bank, bankCode, accountNumber: acctNo, accountName: acctName }
      });
      const updatedMe = await apiFetch('/api/web/me');
      setUser(updatedMe);
      showToast('Withdrawal request submitted! Processing within 24 hours.', 'success');
      setWdAmount(''); setBank(''); setAcctNo(''); setAcctName('');
    } catch(err) { showToast(err.message, 'error'); }
    setWdLoading(false);
  }

  const providerItems = STORE_ITEMS.filter(i => i.provider === provider);
  const starsPerNaira = 1/20;
  const customStars = customAmt ? Math.ceil(parseFloat(customAmt) * starsPerNaira * 1.10) : 0;

  const TABS = [
    { id:'topup',   icon:'💳', label:'Top Up'  },
    { id:'airtime', icon:'📱', label:'Airtime'  },
    { id:'withdraw',icon:'🏦', label:'Withdraw' },
    { id:'orders',  icon:'📦', label:'Orders'   },
  ];

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, letterSpacing:1.5, marginBottom:4 }}>STORE</div>
        <div style={{ fontSize:13, color:'var(--text2)' }}>Top up Stars, buy airtime, withdraw to your bank</div>
      </div>

      {/* Balance cards */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:24 }}>
        <div className="card" style={{ background:'linear-gradient(135deg,rgba(245,200,66,.1),rgba(255,107,53,.05))', border:'1px solid rgba(245,200,66,.2)' }}>
          <div style={{ fontSize:11, color:'var(--muted)', marginBottom:4 }}>TOTAL BALANCE</div>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:'#f5c842', letterSpacing:1 }}>{user?.balance||0} ⭐</div>
          <div style={{ fontSize:11, color:'var(--text2)' }}>≈ ₦{((user?.balance||0)*15).toLocaleString()}</div>
        </div>
        <div className="card" style={{ background:'linear-gradient(135deg,rgba(0,197,102,.08),rgba(0,197,102,.02))', border:'1px solid rgba(0,197,102,.2)' }}>
          <div style={{ fontSize:11, color:'var(--muted)', marginBottom:4 }}>WITHDRAWABLE</div>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:'#00c566', letterSpacing:1 }}>{user?.withdrawableBalance||0} ⭐</div>
          <div style={{ fontSize:11, color:'var(--text2)' }}>≈ ₦{((user?.withdrawableBalance||0)*15).toLocaleString()}</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:6, marginBottom:20, background:'var(--bg1)', borderRadius:12, padding:4 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex:1, padding:'8px 4px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:600,
            background: tab===t.id ? 'var(--bg2)' : 'transparent',
            color: tab===t.id ? 'var(--text)' : 'var(--text2)',
            boxShadow: tab===t.id ? '0 1px 4px rgba(0,0,0,.3)' : 'none',
            display:'flex', alignItems:'center', justifyContent:'center', gap:4
          }}>
            <span>{t.icon}</span><span>{t.label}</span>
          </button>
        ))}
      </div>

      {/* TOP UP TAB */}
      {tab === 'topup' && (
        <div>
          <div style={{ fontSize:13, color:'var(--text2)', marginBottom:16 }}>
            Buy Stars with Naira via Flutterwave. Stars are used to stake on markets and redeem rewards.
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:12, marginBottom:20 }}>
            {FLW_PACKAGES.map(pkg => (
              <div key={pkg.id} onClick={() => setSelPkg(pkg)} style={{
                position:'relative', padding:'16px 14px', borderRadius:14, cursor:'pointer',
                border:`2px solid ${selPkg?.id===pkg.id?'#ff6b35':'var(--border)'}`,
                background: selPkg?.id===pkg.id ? 'rgba(255,107,53,.08)' : 'var(--bg1)',
                transition:'all .15s'
              }}>
                {pkg.popular && <div style={{ position:'absolute', top:-8, right:10, background:'#ff6b35', color:'#000', fontSize:9, fontWeight:700, padding:'2px 8px', borderRadius:10 }}>POPULAR</div>}
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, color:'#f5c842', letterSpacing:1 }}>₦{pkg.ngn.toLocaleString()}</div>
                <div style={{ fontSize:14, fontWeight:700, color:'var(--text)', marginTop:4 }}>
                  {pkg.credits + pkg.bonus} ⭐
                </div>
                {pkg.bonus > 0 && <div style={{ fontSize:11, color:'#00c566', marginTop:2 }}>+{pkg.bonus} bonus ⭐</div>}
                <div style={{ fontSize:10, color:'var(--muted)', marginTop:2 }}>₦{Math.round(pkg.ngn/(pkg.credits+pkg.bonus))}/⭐</div>
              </div>
            ))}
          </div>

          {/* Custom amount */}
          <div className="card" style={{ marginBottom:16 }}>
            <div style={{ fontSize:13, fontWeight:600, marginBottom:10 }}>Custom Amount</div>
            <div style={{ display:'flex', gap:10 }}>
              <input type="number" placeholder="Enter Stars amount (min 50)" min={50}
                style={{ flex:1, padding:'10px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}
                onChange={e => {
                  const stars = parseInt(e.target.value)||0;
                  if (stars >= 50) setSelPkg({ id:'custom', ngn: stars*20, credits: stars, bonus:0, label:'Custom', custom:true });
                }}/>
            </div>
          </div>

          {selPkg && (
            <div style={{ background:'rgba(255,107,53,.06)', border:'1px solid rgba(255,107,53,.2)', borderRadius:12, padding:'12px 16px', marginBottom:16, fontSize:13 }}>
              <div style={{ display:'flex', justifyContent:'space-between' }}>
                <span style={{ color:'var(--text2)' }}>You pay:</span>
                <span style={{ fontWeight:700, color:'var(--text)' }}>₦{selPkg.ngn.toLocaleString()}</span>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', marginTop:4 }}>
                <span style={{ color:'var(--text2)' }}>You receive:</span>
                <span style={{ fontWeight:700, color:'#f5c842' }}>{selPkg.credits + (selPkg.bonus||0)} ⭐ Stars</span>
              </div>
            </div>
          )}

          <button className="btn-primary" onClick={handleTopup} disabled={!selPkg||flwLoading}
            style={{ width:'100%', padding:14, fontSize:15 }}>
            {flwLoading ? 'Opening payment...' : `Pay ₦${selPkg?.ngn?.toLocaleString()||0} → Get ${selPkg?(selPkg.credits+(selPkg.bonus||0)):0} ⭐`}
          </button>
          <div style={{ fontSize:11, color:'var(--muted)', textAlign:'center', marginTop:8 }}>
            Secure payment via Flutterwave · Card, Bank Transfer, USSD supported
          </div>
        </div>
      )}

      {/* AIRTIME TAB */}
      {tab === 'airtime' && (
        <div>
          <div style={{ fontSize:13, color:'var(--text2)', marginBottom:16 }}>
            Redeem your Stars for Nigerian airtime. Rate: 120 ⭐ = ₦100 airtime.
          </div>

          {orderOk && (
            <div style={{ background:'rgba(0,197,102,.08)', border:'1px solid #00c566', borderRadius:12, padding:'16px', marginBottom:16, textAlign:'center' }}>
              <div style={{ fontSize:32, marginBottom:8 }}>✅</div>
              <div style={{ fontWeight:700, fontSize:15, marginBottom:4 }}>Airtime Ordered!</div>
              <div style={{ fontSize:13, color:'var(--text2)' }}>Your airtime will be delivered within a few minutes.</div>
              <button onClick={() => setOrderOk(null)} style={{ marginTop:12, background:'none', border:'1px solid var(--border)', borderRadius:8, color:'var(--text2)', padding:'6px 16px', cursor:'pointer', fontSize:12 }}>Order Another</button>
            </div>
          )}

          {/* Network tabs */}
          <div style={{ display:'flex', gap:8, marginBottom:16 }}>
            {PROVIDERS.map(p => (
              <button key={p} onClick={() => { setProvider(p); setSelItem(null); }}
                style={{ padding:'7px 16px', borderRadius:20, border:'none', cursor:'pointer', fontSize:12, fontWeight:600,
                  background: provider===p ? 'var(--orange)' : 'var(--bg1)',
                  color: provider===p ? '#000' : 'var(--text2)' }}>
                {p}
              </button>
            ))}
          </div>

          {/* Packages */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:16 }}>
            {providerItems.map(item => (
              <div key={item.id} onClick={() => setSelItem(item)} style={{
                padding:'12px', borderRadius:12, cursor:'pointer', textAlign:'center',
                border:`2px solid ${selItem?.id===item.id?'#ff6b35':'var(--border)'}`,
                background: selItem?.id===item.id ? 'rgba(255,107,53,.08)' : 'var(--bg1)',
              }}>
                <div style={{ fontSize:15, fontWeight:700 }}>₦{item.value}</div>
                <div style={{ fontSize:12, color:'#f5c842', marginTop:2 }}>{item.stars} ⭐</div>
              </div>
            ))}
          </div>

          {/* Custom airtime */}
          <div className="card" style={{ marginBottom:16 }}>
            <div style={{ fontSize:12, fontWeight:600, marginBottom:8, color:'var(--text2)' }}>CUSTOM AMOUNT</div>
            <div style={{ display:'flex', gap:10, alignItems:'center' }}>
              <input type="number" placeholder="₦ amount (min ₦125)" value={customAmt}
                onChange={e => { setCustomAmt(e.target.value); setSelItem(null); }}
                style={{ flex:1, padding:'10px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}/>
              {customAmt && customStars >= 150 && (
                <button onClick={() => {
                  setSelItem({ id:`custom_${provider}`, type:'airtime', provider, value:parseFloat(customAmt), stars:customStars, label:`${provider} ₦${customAmt} Airtime`, custom:true });
                  setCustomAmt('');
                }}
                  className="btn-primary" style={{ padding:'10px 14px', fontSize:13, whiteSpace:'nowrap' }}>
                  Select — {customStars} ⭐
                </button>
              )}
              {customAmt && parseInt(customAmt) > 0 && customStars < 150 && (
                <div style={{ fontSize:11, color:'#ff6b35', marginTop:6, width:'100%' }}>Min ₦125 for custom airtime (150 ⭐)</div>
              )}
            </div>
            {customAmt && customStars < 150 && <div style={{ fontSize:11, color:'#ff6b35', marginTop:6 }}>Minimum 150 ⭐ for custom airtime</div>}
          </div>

          {/* Phone input */}
          {selItem && (
            <div className="card" style={{ marginBottom:16 }}>
              <div style={{ fontSize:12, fontWeight:600, marginBottom:8, color:'var(--text2)' }}>RECIPIENT PHONE NUMBER</div>
              <input type="tel" placeholder="e.g. 08012345678" value={phone} onChange={e => handlePhoneChange(e.target.value)}
                style={{ width:'100%', padding:'12px 14px', background:'var(--bg2)',
                  border: `1px solid ${phone.length>=8 ? (detectNetwork(phone) ? detectNetwork(phone)===selItem.provider ? '#00c566' : '#f5c842' : '#ff4444') : 'var(--border)'}`,
                  borderRadius:10, color:'var(--text)', fontSize:15, outline:'none', marginBottom:8 }}/>

              {(()=>{
                if (!phone || phone.length < 8) return null;
                const detected = detectNetwork(phone);
                if (!detected) return <div style={{ fontSize:11, color:'#ff4444', marginBottom:10, padding:'8px 10px', background:'rgba(255,68,68,.08)', borderRadius:8 }}>⚠️ Unknown number prefix — please check the number</div>;
                if (detected !== selItem.provider) return <div style={{ fontSize:11, color:'#f5c842', marginBottom:10, padding:'8px 10px', background:'rgba(245,200,66,.08)', borderRadius:8 }}>⚠️ This looks like a <strong>{detected}</strong> number but you selected <strong>{selItem.provider}</strong>. Please switch network above.</div>;
                return <div style={{ fontSize:11, color:'#00c566', marginBottom:10, padding:'6px 10px', background:'rgba(0,197,102,.08)', borderRadius:8 }}>✅ {detected} number confirmed</div>;
              })()}

              <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:8 }}>
                <span style={{ color:'var(--text2)' }}>You pay:</span>
                <span style={{ fontWeight:700, color:'#ff6b35' }}>{selItem.stars} ⭐ Stars</span>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:16 }}>
                <span style={{ color:'var(--text2)' }}>You receive:</span>
                <span style={{ fontWeight:700, color:'var(--text)' }}>₦{selItem.value} {selItem.provider} Airtime</span>
              </div>

              {user.balance < selItem.stars && (
                <div style={{ fontSize:12, color:'#ff4444', marginBottom:12, textAlign:'center', padding:'8px', background:'rgba(255,68,68,.06)', borderRadius:8 }}>
                  ❌ Need {selItem.stars - user.balance} more ⭐. Top up your balance first.
                </div>
              )}

              <button className="btn-primary" onClick={handleAirtime}
                disabled={airtimeLoading || !phone || phone.length < 11 || !detectNetwork(phone) || detectNetwork(phone) !== selItem.provider || user.balance < selItem.stars}
                style={{ width:'100%', padding:13, fontSize:14 }}>
                {airtimeLoading ? 'Processing...' : `Confirm — ${selItem.stars} ⭐ for ₦${selItem.value} ${selItem.provider} Airtime`}
              </button>
            </div>
          )}
        </div>
      )}

      {/* WITHDRAW TAB */}
      {tab === 'withdraw' && (
        <div>
          {!user?.ninVerified && (
            <div style={{ background:'rgba(255,107,53,.08)', border:'1px solid rgba(255,107,53,.3)', borderRadius:14, padding:'16px 18px', marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                <span style={{ fontSize:20 }}>🪪</span>
                <div style={{ fontSize:14, fontWeight:700, color:'var(--orange)' }}>NIN Verification Required</div>
              </div>
              <div style={{ fontSize:12, color:'var(--text2)', marginBottom:12, lineHeight:1.6 }}>
                You must verify your NIN before you can withdraw. Verify now to also receive <strong style={{color:'#f5c842'}}>100 ⭐ Stars free</strong>.
              </div>
              <button className="btn-primary" onClick={() => navigate('/profile?tab=account')} style={{ width:'100%', padding:12, fontSize:13 }}>
                🪪 Verify NIN Now
              </button>
            </div>
          )}
          <div style={{ background:'rgba(0,197,102,.06)', border:'1px solid rgba(0,197,102,.2)', borderRadius:12, padding:'14px 16px', marginBottom:20 }}>
            <div style={{ fontSize:13, fontWeight:600, color:'#00c566', marginBottom:4 }}>Withdrawable Balance</div>
            <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, color:'#00c566' }}>{user?.withdrawableBalance||0} ⭐</div>
            <div style={{ fontSize:12, color:'var(--text2)', marginTop:2 }}>≈ ₦{((user?.withdrawableBalance||0)*15).toLocaleString()} · Rate: ₦15 per ⭐</div>
          </div>

          <div className="card" style={{ marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:16 }}>Bank Details</div>
            <div style={{ display:'grid', gap:12 }}>

              {/* Bank Search */}
              <div style={{ position:'relative' }}>
                <label style={{ fontSize:11, color:'var(--text2)', fontWeight:600, letterSpacing:.5 }}>BANK NAME</label>
                <input type="text" placeholder="Search bank e.g. Access, GTB..." value={bankSearch}
                  onChange={e => { setBankSearch(e.target.value); setShowBankList(true); setBank(''); setBankCode(''); }}
                  onFocus={() => setShowBankList(true)}
                  onBlur={() => setTimeout(()=>setShowBankList(false), 200)}
                  style={{ width:'100%', marginTop:6, padding:'11px 14px', background:'var(--bg2)', border:`1px solid ${bank?'#00c566':'var(--border)'}`, borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}/>
                {bank && <div style={{ fontSize:11, color:'#00c566', marginTop:4 }}>✅ {bank} selected</div>}
                {showBankList && bankSearch.length >= 2 && (
                  <div style={{ position:'absolute', top:'100%', left:0, right:0, background:'var(--bg1)', border:'1px solid var(--border)', borderRadius:10, maxHeight:200, overflowY:'auto', zIndex:200, marginTop:4, boxShadow:'0 8px 32px rgba(0,0,0,.4)' }}>
                    {banks.filter(b => b.name?.toLowerCase().includes(bankSearch.toLowerCase())).slice(0,10).map(b => (
                      <div key={b.code} onMouseDown={() => { setBank(b.name); setBankCode(b.code); setBankSearch(b.name); setShowBankList(false); if(acctNo.length===10) lookupAccount(acctNo, b.code); }}
                        style={{ padding:'10px 14px', cursor:'pointer', fontSize:13, borderBottom:'1px solid var(--border)', transition:'background .1s' }}
                        onMouseEnter={e=>e.currentTarget.style.background='var(--bg2)'}
                        onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                        {b.name}
                      </div>
                    ))}
                    {banks.filter(b => b.name?.toLowerCase().includes(bankSearch.toLowerCase())).length===0 && (
                      <div style={{ padding:'12px 14px', fontSize:13, color:'var(--muted)' }}>No banks found</div>
                    )}
                  </div>
                )}
              </div>

              {/* Account Number */}
              <div>
                <label style={{ fontSize:11, color:'var(--text2)', fontWeight:600, letterSpacing:.5 }}>ACCOUNT NUMBER</label>
                <input type="text" placeholder="10-digit account number" value={acctNo} maxLength={10}
                  onChange={e => { setAcctNo(e.target.value); setAcctName(''); setAcctNameVerified(false); if(e.target.value.length===10 && bankCode) lookupAccount(e.target.value, bankCode); }}
                  style={{ width:'100%', marginTop:6, padding:'11px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}/>
                {acctNo.length===10 && !bankCode && <div style={{ fontSize:11, color:'#f5c842', marginTop:4 }}>⚠️ Select a bank first to verify account name</div>}
              </div>

              {/* Account Name - auto detected */}
              <div>
                <label style={{ fontSize:11, color:'var(--text2)', fontWeight:600, letterSpacing:.5 }}>ACCOUNT NAME</label>
                {acctNameLoading ? (
                  <div style={{ marginTop:6, padding:'11px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, fontSize:13, color:'var(--muted)' }}>🔍 Verifying account...</div>
                ) : acctNameVerified ? (
                  <div style={{ marginTop:6, padding:'11px 14px', background:'rgba(0,197,102,.06)', border:'1px solid #00c566', borderRadius:10, fontSize:14, color:'#00c566', fontWeight:600 }}>✅ {acctName}</div>
                ) : (
                  <input type="text" placeholder="Auto-detected when you enter account number" value={acctName} onChange={e=>setAcctName(e.target.value)}
                    style={{ width:'100%', marginTop:6, padding:'11px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}/>
                )}
              </div>

              {/* Amount */}
              <div>
                <label style={{ fontSize:11, color:'var(--text2)', fontWeight:600, letterSpacing:.5 }}>AMOUNT (Stars)</label>
                <input type="number" placeholder="Min 200 Stars = ₦3,000" value={wdAmount} onChange={e=>setWdAmount(e.target.value)} min={500}
                  style={{ width:'100%', marginTop:6, padding:'11px 14px', background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:10, color:'var(--text)', fontSize:14, outline:'none' }}/>
                {wdAmount && <div style={{ fontSize:12, color:'#00c566', marginTop:6 }}>You receive: ₦{(parseInt(wdAmount)||0)*15} in your bank account</div>}
              </div>
            </div>
          </div>

          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:16, lineHeight:1.7 }}>
            ⚠️ Only Stars earned from winning predictions are withdrawable. Signup bonus Stars must be used for staking first. Processing time: up to 24 hours.
          </div>

          <button className="btn-primary" onClick={handleWithdraw} disabled={wdLoading||!wdAmount||parseInt(wdAmount)<200}
            style={{ width:'100%', padding:14, fontSize:15 }}>
            {wdLoading ? 'Submitting...' : `Withdraw ${wdAmount||0} ⭐ → ₦${(parseInt(wdAmount)||0)*15}`}
          </button>
        </div>
      )}

      {/* ORDERS TAB */}
      {tab === 'orders' && (
        <div>
          <div style={{ fontSize:13, color:'var(--text2)', marginBottom:16 }}>Your airtime and redemption history</div>
          {orders.length === 0 ? (
            <div style={{ textAlign:'center', padding:'50px 0', color:'var(--muted)' }}>
              <div style={{ fontSize:40, marginBottom:8 }}>📦</div>
              <div>No orders yet</div>
            </div>
          ) : orders.map(o => (
            <div key={o.id} className="card" style={{ marginBottom:10, padding:'14px 16px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:600 }}>{o.item_label}</div>
                  <div style={{ fontSize:11, color:'var(--muted)', marginTop:2 }}>{new Date(o.created_at).toLocaleDateString('en-NG',{day:'numeric',month:'short',year:'numeric'})}</div>
                  {o.phone && <div style={{ fontSize:11, color:'var(--text2)', marginTop:2 }}>📱 {o.phone}</div>}
                </div>
                <div style={{ textAlign:'right' }}>
                  <span style={{ fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:20,
                    background: o.status==='fulfilled'?'rgba(0,197,102,.1)':o.status==='pending'?'rgba(245,200,66,.1)':'rgba(255,68,68,.1)',
                    color: o.status==='fulfilled'?'#00c566':o.status==='pending'?'#f5c842':'#ff4444' }}>
                    {o.status==='fulfilled'?'✅ Delivered':o.status==='pending'?'⏳ Pending':'❌ Cancelled'}
                  </span>
                  <div style={{ fontSize:13, fontWeight:700, color:'#ff6b35', marginTop:6 }}>-{o.stars_spent} ⭐</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
